<template>
  <v-bottom-navigation app class="w-100 d-lg-none" v-if="!hideNav" @click="goTo(targetQuerySelector, {
      duration: 300,
      easing: 'easeInOutCubic',
      offset: targetElementTopOffset,
    });">
    <v-btn class="w-100" stacked prepend-icon="fa-solid fa-file-pen" text="参加申込をする" />
  </v-bottom-navigation>
</template>
<script setup lang="ts">
interface Props {
  targetQuerySelector: string;
  targetElementTopOffset: number;
};
const props = defineProps<Props>();

import { useGoTo } from 'vuetify';
const goTo = useGoTo();

import { ref, onMounted, onBeforeUnmount } from 'vue';
const hideNav = ref(false);
let observer: IntersectionObserver;

onMounted(() => {
  const target = document.querySelector(props.targetQuerySelector);

  if (!target) return;
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        hideNav.value = entry.isIntersecting
      })
    },
    {
      root: null, // viewport
      threshold: 0.1, // 少しでも見えたらtrue
    }
  );
  observer.observe(target);
});

onBeforeUnmount(() => {
  if (!observer) return;
  observer.disconnect();
});
</script>